import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ResetPasswordPayload } from '../../../../../Interfaces/api/Intune/users.interface';
import { generateSecurePassword } from '../../../../Shared/Utils/password.utils';

@Component({
  selector: 'app-reset-password-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss', '../../../../../../assets/theme/cutom/_av-dialog.scss'],
})
export class ResetPasswordDialogComponent implements OnInit {
  private readonly _fb = inject(FormBuilder);

  form!: FormGroup;
  hidePassword = true;

  constructor(
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent, ResetPasswordPayload>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) { }

  ngOnInit(): void {
    this.form = this._fb.nonNullable.group({
      password: [generateSecurePassword(), [Validators.required, Validators.minLength(8)]],
      forceChangePasswordNextSignIn: [true],
    });
  }

  regeneratePassword(): void {
    this.form.patchValue({ password: generateSecurePassword() });
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    const { password, forceChangePasswordNextSignIn } = this.form.getRawValue();
    this.dialogRef.close({ password, forceChangePasswordNextSignIn });
  }
}
